import { jsx, jsxs } from "react/jsx-runtime";
import { Box, FormControl, FormHelperText, FormLabel, RadioGroup as MuiRadioGroup } from "@mui/material";
import { useMemo } from "react";
import { useFormFairyBridge } from "../../hooks/useFormFairyBridge.js";
import { RadioGroupOption } from "./RadioGroupOption.js";
function RadioGroup(props) {
  const { ariaLabel, label, options, radioGroupProps = {}, ...bridgeOptions } = props;
  const {
    config: { fullWidth, name, testId = "radio-group-root" },
    fieldInfo: {
      errorOrHelperText,
      field: { required, visible },
      fieldDisabled,
      fieldHasError,
      onBlur,
      onChange,
      onFocus,
      showHelperText,
      value
    }
  } = useFormFairyBridge(bridgeOptions);
  const handleOnChange = (event) => {
    const value2 = event.target.value;
    onChange(value2);
  };
  const optionsWithComponentDisabledState = useMemo(() => {
    if (!fieldDisabled) return options;
    return options.map((o) => ({ ...o, disabled: true }));
  }, [options, fieldDisabled]);
  if (!visible) return null;
  const fieldAriaLabel = ariaLabel ? ariaLabel : typeof label === "string" ? label : void 0;
  return /* @__PURE__ */ jsxs(
    FormControl,
    {
      variant: "standard",
      component: "fieldset",
      fullWidth,
      disabled: fieldDisabled,
      error: fieldHasError,
      "data-testid": testId,
      "data-tidal": "RadioGroup",
      children: [
        /* @__PURE__ */ jsx(Box, { paddingBottom: 0.5, children: /* @__PURE__ */ jsx(FormLabel, { component: "legend", required, children: label }) }),
        /* @__PURE__ */ jsx(
          MuiRadioGroup,
          {
            "aria-label": fieldAriaLabel,
            ...radioGroupProps,
            name,
            value,
            onBlur,
            onFocus,
            onChange: handleOnChange,
            children: optionsWithComponentDisabledState.map((option) => /* @__PURE__ */ jsx(RadioGroupOption, { option }, option.value))
          }
        ),
        showHelperText && /* @__PURE__ */ jsx(FormHelperText, { error: fieldHasError, children: errorOrHelperText })
      ]
    }
  );
}
export {
  RadioGroup
};
//# sourceMappingURL=RadioGroup.js.map
